module.exports = __webpack_public_path__ + "static/media/ecell_logo.69b64b75.jpg";